var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H31C32.6569 0 34 1.34315 34 3V31C34 32.6569 32.6569 34 31 34H3C1.34315 34 0 32.6569 0 31V3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7H23C24.1 7 25 7.9 25 9V13.32H9V9C9 7.9 9.9 7 11 7Z",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.3203V16.8803C9 17.9603 9.58003 18.9603 10.53 19.4903L13.49 21.1603C14.12 21.5103 14.51 22.1803 14.51 22.9003V25.0003C14.51 26.1003 15.41 27.0003 16.51 27.0003H17.51C18.61 27.0003 19.51 26.1003 19.51 25.0003V22.9003C19.51 22.1803 19.9 21.5103 20.53 21.1603L23.49 19.4903C24.43 18.9603 25.02 17.9603 25.02 16.8803V13.3203H9Z",
    stroke: "#0068FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 1H31V-1H3V1ZM33 3V31H35V3H33ZM31 33H3V35H31V33ZM1 31V3H-1V31H1ZM3 33C1.89543 33 1 32.1046 1 31H-1C-1 33.2091 0.790862 35 3 35V33ZM33 31C33 32.1046 32.1046 33 31 33V35C33.2091 35 35 33.2091 35 31H33ZM31 1C32.1046 1 33 1.89543 33 3H35C35 0.790861 33.2091 -1 31 -1V1ZM3 -1C0.790861 -1 -1 0.790862 -1 3H1C1 1.89543 1.89543 1 3 1V-1Z",
    fill: "#E7E6E6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.fa61408e63b074643cf95d89a931e772.svg";
export { ForwardRef as ReactComponent };